import { CommonModule } from '@angular/common';
import { ShelterProfileDataService } from './services/shelter-profile-data/shelter-profile-data.service';
import { AttendancePanelModule } from './profile-panels/attendance-panel/attendance-panel.module';
import { BasicInfoPanelModule } from './profile-panels/basic-info-panel/basic-info-panel.module';
import { ProfileHeaderModule } from './profile-header/profile-header.module';
import { NvSidebarListModule } from './../../../nvps-libraries/design/nv-sidebar-list/nv-sidebar-list.module';
import { NgModule } from '@angular/core';
import { ShelterProfileComponent } from './shelter-profile.component';
import { ShelterProfileRoutingModule } from './shelter-profile-routing.module';

@NgModule({
  declarations: [ShelterProfileComponent],
  imports: [
    NvSidebarListModule,
    ProfileHeaderModule,
    BasicInfoPanelModule,
    AttendancePanelModule,
    CommonModule,
    ShelterProfileRoutingModule,
  ],
  exports: [],
  providers: [ShelterProfileDataService],
})
export class ShelterProfileModule {}
